import type { UploadQuotaExceededDetail } from "@/lib/apiErrors";

type GlobalApiErrorEventMap = {
  uploadQuotaExceeded: UploadQuotaExceededDetail;
};

type EventKey = keyof GlobalApiErrorEventMap;
type EventListener<K extends EventKey> = (
  detail: GlobalApiErrorEventMap[K],
) => void;

const listeners: {
  [K in EventKey]: Set<EventListener<K>>;
} = {
  uploadQuotaExceeded: new Set<EventListener<"uploadQuotaExceeded">>(),
};

export const subscribeGlobalApiError = <K extends EventKey>(
  eventKey: K,
  listener: EventListener<K>,
): (() => void) => {
  listeners[eventKey].add(listener);
  return () => {
    listeners[eventKey].delete(listener);
  };
};

export const publishGlobalApiError = <K extends EventKey>(
  eventKey: K,
  detail: GlobalApiErrorEventMap[K],
) => {
  listeners[eventKey].forEach((listener) => {
    listener(detail);
  });
};
